"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _MarketingHeader = _interopRequireDefault(require("./MarketingHeader"));

var _MobxPageContent = _interopRequireDefault(require("../../shared/components/MobxPageContent"));

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _CookieConsent = _interopRequireDefault(require("../../shared/components/CookieConsent"));

var _MarketingSubfooter = _interopRequireDefault(require("../components/MarketingSubfooter"));

var _excluded = ["session"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var MarketingPageContent = /*#__PURE__*/function (_React$Component) {
  _inherits(MarketingPageContent, _React$Component);

  var _super = _createSuper(MarketingPageContent);

  function MarketingPageContent() {
    _classCallCheck(this, MarketingPageContent);

    return _super.apply(this, arguments);
  }

  _createClass(MarketingPageContent, [{
    key: "render",
    value: function render() {
      var _otherProps$defaultPr, _otherProps$legalText, _this$props$session;

      var _this$props = this.props,
          session = _this$props.session,
          otherProps = _objectWithoutProperties(_this$props, _excluded);

      var defaultProduct = (_otherProps$defaultPr = otherProps === null || otherProps === void 0 ? void 0 : otherProps.defaultProduct) !== null && _otherProps$defaultPr !== void 0 ? _otherProps$defaultPr : 1;
      var enableSubfooter = otherProps === null || otherProps === void 0 ? void 0 : otherProps.enableSubfooter;
      var legalTextKeys = (_otherProps$legalText = otherProps === null || otherProps === void 0 ? void 0 : otherProps.legalTextKeys) !== null && _otherProps$legalText !== void 0 ? _otherProps$legalText : [];
      var isLoggedIn = session === null || session === void 0 ? void 0 : session.isLoggedIn;
      var requestInfoUrl = (_this$props$session = this.props.session) === null || _this$props$session === void 0 ? void 0 : _this$props$session.requestInfoUrl;

      var header = /*#__PURE__*/_react.default.createElement(_MarketingHeader.default, {
        className: "header-splash",
        isLoggedIn: isLoggedIn,
        showLoginLink: this.props.showLoginLink,
        requestInfoUrl: requestInfoUrl
      });

      return /*#__PURE__*/_react.default.createElement(_MobxPageContent.default, _extends({}, otherProps, {
        header: header
      }), this.props.children, enableSubfooter && /*#__PURE__*/_react.default.createElement(_MarketingSubfooter.default, {
        defaultProduct: defaultProduct,
        legalTextKeys: legalTextKeys,
        requestInfoUrl: requestInfoUrl
      }), /*#__PURE__*/_react.default.createElement(_CookieConsent.default, null));
    }
  }]);

  return MarketingPageContent;
}(_react.default.Component);

var _default = (0, _Propulator.default)(MarketingPageContent, {
  sessionStore: {
    session: "session"
  }
});

exports.default = _default;